import { API_ROOT_ORGS, API_ROOT_USERS, API_HOST_ORGS_SEARCH } from "../config";
import { OrgsService } from "./business/OrgsService";
import { AwardingOrgService } from "./business/AwardingOrgService";
import { TeamsService } from "./business/TeamsService";
import { UsersService } from "./business/UsersService";
import { LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import titles from "./json/titles.json";
export const usersService = new UsersService(API_ROOT_USERS);
export const teamsService = new TeamsService(API_ROOT_USERS);
export const orgsService = new OrgsService(API_ROOT_ORGS);
export const aoService = new AwardingOrgService(API_HOST_ORGS_SEARCH);
export const titlesService = new LocalLookupService(titles);